export const QUALTRICS_LOGIN_URL = 'https://decibio.qualtrics.com/login';
export const QUALTRICS_SURVEY_URL = `${QUALTRICS_LOGIN_URL}?path=%2Fsurvey-builder`;
export const QUALTRICS_SURVEY_RESPONSE_URL = `${QUALTRICS_LOGIN_URL}?path=%2FQ%2FData%2FAjax%2FGetSingleResponseReport%3F`;
